import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-83ee5f8e"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "list-warp"
};
const _hoisted_3 = {
  key: 0,
  class: "no-data"
};
import SectionContainer from './SectionContainer.vue';
import CardHeader from '../../components/CardHeader.vue';
import CourseCard from '../../teachCenter/components/CourseCard.vue';
import { Empty } from 'zhs-components';
export default {
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    provide('menuInfo', ref(props.menu));
    const courseList = ref([]);

    const getMyCourseList = async () => {
      const res = await $http.getResearchCourseList({
        '_pageable.page': 0,
        '_pageable.size': 5
      });
      courseList.value = res.content;
    };

    getMyCourseList();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SectionContainer, {
        title: __props.menu.module_name,
        bg: `linear-gradient(180deg, #fff 0%, var(--el-color-primary-light-9) 42%)`
      }, {
        action: _withCtx(() => [_createElementVNode("a", {
          href: `/researchCourseList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
        }, " 全部 > ", 8, _hoisted_1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value.slice(0, 5), item => {
          return _openBlock(), _createBlock(CourseCard, {
            class: "item",
            key: item.id,
            showDel: false,
            courseData: { ...item,
              id: item.course_id
            },
            type: 4,
            menuInfo: __props.menu
          }, null, 8, ["courseData", "menuInfo"]);
        }), 128))]), courseList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(Empty), {
          text: "暂无教研课程"
        })])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["title", "bg"]);
    };
  }

};